export const MENU_ACTION_SHOW = 'show';
export const MENU_ACTION_HIDE = 'hide';
export const MENU_ACTION_REQUIRED = 'required';
export const MENU_ACTION_OPTIONAL = 'optional';
export const MENU_ACTION_EDIT_OPTIONALS = 'edit-options';
export const MENU_ACTION_DELETE = 'delete';
export const MENU_ACTION_ADD_RULE = 'add-rule';
